var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.computedClass }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.modelValue,
          expression: "modelValue",
        },
      ],
      ref: "radio-button",
      attrs: {
        type: "radio",
        id: _vm.id ?? _vm.name,
        name: _vm.name,
        disabled: _vm.disabled,
      },
      domProps: { checked: _vm._q(_vm.modelValue, null) },
      on: {
        change: function ($event) {
          _vm.modelValue = null
        },
      },
    }),
    _c("label", { attrs: { for: _vm.id ?? _vm.name } }, [
      _c("span", { class: _vm.computedClassIndicator }, [
        _c("i", { staticClass: "jade-radio-button__marker" }),
      ]),
      _vm.label
        ? _c(
            "div",
            { staticClass: "jade-radio-button__label" },
            [
              _c(
                "JadeText",
                {
                  attrs: {
                    variant: "text-medium",
                    weight: "regular",
                    color: "current-color",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.label) + " ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.supportText
        ? _c(
            "div",
            { staticClass: "jade-radio-button__support" },
            [
              _c(
                "JadeText",
                {
                  attrs: {
                    variant: "text-small",
                    weight: "regular",
                    color: "current-color",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.supportText) + " ")]
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }